module.exports = __webpack_public_path__ + "img/q_53_sor.ffb0b6af.png";